import { useState, useEffect, useMemo, forwardRef } from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  ListSubheader,
  TextField,
  InputAdornment,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { getAllCustomers } from 'src/services/projectService';

interface ClientMultiSelectProps {
  value: string | string[] | [],
  onChange: (e: any) => void,
}

const ClientMultiSelect = forwardRef((props: ClientMultiSelectProps, _ref) => {
  const [clients, setClients] = useState([]);
  const [selectedClients, setSelectedClients] = useState<string[]>([]);
  const [searchText, setSearchText] = useState<string>('');
  
  const containsText = (text, searchText) =>
    text?.toLowerCase().indexOf(searchText?.toLowerCase()) > -1;

  useEffect(() => {
    const fetchClients = () => {
      getAllCustomers().then((res) => {
        setClients((res.data) || []);
      });
    }

    fetchClients();
  }, []);


  const filteredClients = useMemo(
    () =>
      clients.length > 0 &&
      clients?.filter((option) => containsText(option?.name, searchText)),
    [clients, searchText]
  );

  useEffect(() => {
    const clientsSelectedName = [];
    if(props?.value && props?.value.length > 0){
      for(let i=0; i < props?.value.length; i++){
        const result = clients.filter(e => e.id.toString() === props?.value[i]);
        clientsSelectedName.push(result[0]?.name);
      }
    }
    setSelectedClients(clientsSelectedName);
  }, [clients, props?.value]);

  return (
    <FormControl fullWidth>
      <InputLabel
        style={{
          fontSize: '12px'
        }}
      >
        Client Name
      </InputLabel>
      <Select
        id="filter-resource"
        sx={{ mt: 1 }}
        style={{
          fontSize: '12px',
          height: '2rem'
        }}
        multiple
        size="small"
        value={props.value}
        renderValue={() => selectedClients.join(', ')}
        onChange={(e) => props?.onChange(e)}
        onClose={() => setSearchText('')}
      >
        <ListSubheader>
          <TextField
            id="search-stakeholderRole"
            size="small"
            autoFocus
            placeholder="Type to search..."
            fullWidth
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              )
            }}
            onChange={(e) => setSearchText(e.target.value)}
            onClick={(e) => {
              e.stopPropagation();
            }}
            onKeyDown={(e) => {
              if (e.key !== 'Escape') {
                e.stopPropagation();
              }
            }}
          ></TextField>
        </ListSubheader>
        {
          filteredClients?.length > 0 &&
          filteredClients.map((clients, i) => {
            return (
              <MenuItem key={clients?.id} 
                value={clients?.id}>
                  <Checkbox checked={props?.value.indexOf(clients?.id as never) > -1} />
                  <ListItemText primary={clients?.name} />
              </MenuItem>
            );
          })
        }
      </Select>
    </FormControl>
  );
});

export default ClientMultiSelect;
